<template>
  <div class="Home">
    <div class="common_top">
      <img src="../assets/img/logo.png" class="common_top_img" />
      <span>账号注册</span>
    </div>
    <div class="content-main">
      <div class="main-top">
        <div>官网：www.fsyg.cn</div>
        <div>客服：4000309003</div>
      </div>
      <el-form
        ref="form"
        :model="form"
        label-width="auto"
        :label-position="isMobile ? 'top' : 'left'"
        :rules="rules"
      >
        <el-form-item prop="username">
          <template slot="label">
            <span style="font-weight:bold">注册云购账号:</span>
          </template>

          <template>
            <el-input v-model="form.username" placeholder="用于登录凡商云购">
            </el-input>
          </template>
          <span class="el-icon-info" style="">建议：门店首写字母+数字</span>
        </el-form-item>
        <el-form-item prop="password">
          <template slot="label">
            <span style="font-weight:bold">设置云购密码:</span>
          </template>
          <el-input
            type="password"
            v-model="form.password"
            placeholder="请输入6位以上字母、数字组合"
          ></el-input>
        </el-form-item>
        <el-form-item label="确定密码:" prop="newPassword">
          <el-input
            type="password"
            v-model="form.newPassword"
            placeholder="请再次输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店名称:" prop="realname">
          <el-input
            placeholder="请输入门店名称"
            v-model="form.realname"
          ></el-input>
        </el-form-item>
        <el-form-item label="门店区域:" prop="province">
          <template>
            <div>
              <el-select
                @change="provinceChange"
                v-model="form.province"
                placeholder="请选择"
                class="selectBox"
              >
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item.area_name"
                  :value="item.area_code"
                >
                </el-option>
              </el-select>
              <el-form-item style="width: 100%" prop="city">
                <el-select
                  @change="cityChange"
                  v-model="form.city"
                  placeholder="请选择"
                  class="selectBox"
                >
                  <el-option
                    v-for="(item, index) in cityList"
                    :key="index"
                    :label="item.area_name"
                    :value="item.area_code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 100%" prop="area">
                <el-select
                  class="selectBox"
                  v-model="form.area"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(item, index) in areaList"
                    :key="index"
                    :label="item.area_name"
                    :value="item.area_code"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="门店地址:">
          <el-input type="textarea" v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label="启用扫码支付:" prop="allow_scan">
          <el-radio-group v-model="form.allow_scan">
            <el-radio label="2">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
          <i class="el-icon-info" @click="showTip"></i>
        </el-form-item>
        <el-form-item label="手机号码:" prop="phone">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item label="短信验证码:" prop="msg">
          <template>
            <div class="code">
              <el-input
                class="codeInput"
                v-model="form.msg"
                placeholder="请输入验证码"
              ></el-input>
              <div class="code-left" v-if="iscode" @click="codeBtn">
                {{ codes }}
              </div>
              <div class="code-left2" v-if="!iscode">{{ tiems }}s</div>
            </div>
          </template>
        </el-form-item>
        <div class="agreement_box">
          <el-checkbox v-model="checked"
            >注册须同意凡商云购
            <a @click="turnAgreement" class="agreement">《用户使用协议》</a>
          </el-checkbox>
        </div>
        <el-form-item>
          <!-- <el-button type="primary" @click="onSubmit">立即创建</el-button> -->
          <div style="width:100%;display:flex;justify-content: center;">
            <el-button
              :loading="btnloading"
              style="background-color: #ff7b08; color: #fff; width: 60%;margin:0 auto"
              @click="register('form')"
              >注 册
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="verifyVisible" class="code-verify">
      <div class="verify-inner">
        <div @click="handleCloseVerify" class="close-btn">
          <i class="el-icon-close"></i>
        </div>
        <div class="row">
          <img
            :src="verifyInfo.image"
            alt="点击获取图形验证码"
            @click="getCodeImg"
          />
        </div>
        <div class="row">
          <el-input
            v-model.trim="verifyInfo.captcha"
            placeholder="请输入图形验证码"
            maxLength="6"
            :disabled="!verifyInfo.captcha_id || verifyLoading"
            clearable
          ></el-input>
        </div>
        <div class="row">
          <el-button
            @click="handleVerifySubmit"
            class="verify-btn"
            type="primary"
            size="small"
            :loading="verifyLoading"
            :disabled="!verifyInfo.captcha_id"
            plain
            >立即验证</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseURL } from "@/util/config";
const initVerifyInfo = () => ({
  captcha_id: '',
  image: '',
  captcha: '',
})

export default {
  name: "home",
  data() {
    const reg = new RegExp(/\s/);
    var checkusername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入门店账号"));
      }
      setTimeout(() => {
        if (/[\u4E00-\u9FA5\uF900-\uFA2D]/.test(value)) {
          callback(new Error("不能输入中文"));
        } else if (value.indexOf(" ") >= 0) {
          callback(new Error("不能有空格"));
        } else if (reg.test(value)) {
          callback(new Error("不能有空格"));
        } else {
          callback();
        }
      });
    };
    return {
      // url: location.origin,
      url: baseURL,
      btnloading: false,
      region: "",
      wb_id: "",
      provinceList: [],
      cityList: [],
      areaList: [],
      form: {
        newPassword: "",
        username: "",
        password: "",
        realname: "",
        province: "",
        city: "",
        area: "",
        address: "",
        snbid: "",
        phone: "",
        msg: "",
        shiftJf: 1,
        allow_scan: ""
      },
      codes: "获取验证码",
      isMobile: window.innerWidth < 500,
      tiems: 60,
      iscode: true,
      checked: false,
      codeStatus: true, //获取验证码状态
      rules: {
        province: [
          { required: true, message: "请选择省市区", trigger: "blur" }
        ],
        city: [{ required: true, message: "请选择市区" }],
        area: [{ required: true, message: "请选择区", trigger: "blur" }],
        username: [
          { required: true, message: "请输入云购账号", trigger: "blur" },
          { validator: checkusername, trigger: "blur" }
        ],
        realname: [
          { required: true, message: "请输入云购名称", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入云购密码", trigger: "blur" },
          { min: 6, message: "长度必须大于6位", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入确定密码", trigger: "blur" },
          { min: 6, message: "长度必须大于6位", trigger: "blur" }
        ],
        allow_scan: [
          {
            required: true,
            message: "请选择是否启用在线支付",
            trigger: "blur"
          }
        ],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        msg: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      verifyVisible: false,
      verifyLoading: false,
      verifyInfo: initVerifyInfo()
    };
  },
  watch: {
    verifyVisible(newVal) {
      if (newVal) {
        this.getCodeImg();
      }
    }
  },
  created() {
    let registerInfo = this.filterInfo();
    console.log(registerInfo);
    this.form = { ...this.form, ...registerInfo };
    // console.log(this.form)
    // this.form.province = this.getQueryVariable("province");
    // this.form.city = this.getQueryVariable("city");
    // this.form.address = this.getQueryVariable("link_address");
    // this.form.snbid = this.getQueryVariable("snbid");
    // this.region = this.getQueryVariableaddress("region");
    // this.form.realname = this.getQueryVariable("name");
    // if (this.getQueryVariable("shiftJf") === 0) {
    //   this.form.shiftJf = 0;
    // }

    this.region = registerInfo.region;
    this.form.address = registerInfo.link_address;

    this.getProvinceList();
    this.getCityList();
    this.getAreaList();

    //埋点
    axios.post(this.url + "/wbInfo/buryingPoint", {
      type: 1,
      snbid: this.form.snbid
    });
  },
  mounted() {
    //获取数据
    let data = localStorage.getItem("formData");

    if (data) {
      this.form = JSON.parse(data);
    }
  },
  methods: {
    handleCloseVerify() {
      this.verifyVisible = false;
      this.verifyLoading = false;
      this.codeStatus = true;
      this.verifyInfo = initVerifyInfo();
    },
    getCodeImg() {
      if(this.verifyLoading) {
        return
      }
      axios
        .post(this.url + "/wbInfo/sendCaptcha", {})
        .then(res => {
          console.log('getCodeImage:::',res)
          if (res.data.code === 0) {
            this.verifyInfo.captcha = '';
            this.verifyInfo.captcha_id = res.data.data.captcha_id;
            this.verifyInfo.image = res.data.data.image;
          }
        });
    },
    handleVerifySubmit() {
      if(!this.verifyInfo.captcha_id){
        this.$message({
          type: 'warning',
          message: '请重新获取图形验证码',
          customClass: 'code-verify-message'
        });
        return
      }
      if (!this.verifyInfo.captcha) {
        this.$message({
          type: 'warning',
          message: '请输入图形验证码',
          customClass: 'code-verify-message'
        });
        return;
      }
      this.verifyLoading = true;
      axios
        .post(this.url + "/wbInfo/verifyCaptcha", {
          captcha_id: this.verifyInfo.captcha_id,
          captcha: this.verifyInfo.captcha
        })
        .then(res => {
          console.log('verifyCaptcha:::',res)
          this.verifyLoading = false;
          if (res.data.code === 0) {
            this.handleCloseVerify();
            this.sendCode(res.data.data.captcha_token);
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg,
              customClass: 'code-verify-message'
            });
            this.getCodeImg();
          }
        }).catch(error => {
          this.verifyLoading = false;
          this.getCodeImg();
        })
    },
    showTip() {
      this.$alert(
        "1.开启后：客人可用微信/支付宝扫码付款；<br/>2.当前不开启，后续仍可在门店管理后台-系统设置-扫码支付菜单中开启；<br/>3.查账：门店后台-报表菜单和凡商云购公众号均可查询扫码营收数据；",
        "提示",
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false
          // confirmButtonText: '确定',
          // callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
          // }
        }
      );
      // this.$message({
      //   type:'info',
      //   message:'1.开启后：客人可用微信/支付宝扫码付款；2.当前不开启，后续仍可在门店管理后台-系统设置-在线支付菜单中开启；3.查账：门店后台-报表菜单和凡商云购公众号均可查询扫码营收数据；'
      // })
    },
    getregionInfo() {
      let that = this;
      this.areaList.map(item => {
        if (that.region == item.area_name) {
          that.form.area = item.area_code;
        }
      });
    },
    getQueryVariable(variable) {
      const after = window.location.href.split("?", 2)[1];
      if (after) {
        const reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)");
        const r = after.match(reg);
        if (r != null) {
          console.log(decodeURIComponent(r[2]));
          return decodeURIComponent(r[2]);
        } else {
          return "";
        }
      }
    },
    filterInfo() {
      const str = decodeURIComponent(window.location.href.split("?")[1]);
      const str1 = str.split("#/");
      const arr = str1[0].split("&");
      const obj = {};
      arr.forEach(item => {
        const oneItem = item.split("=");
        if (item.indexOf("#") >= 0) {
          item.split("#/");
        }
        obj[oneItem[0]] = oneItem[1];
      });
      return obj;
    },
    getQueryVariableaddress(variable) {
      const after = window.location.href.split("?", 2)[1];
      if (after) {
        const reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)");
        const r = after.match(reg);
        if (r != null) {
          console.log(decodeURIComponent(r[2]));
          return decodeURIComponent(r[2].slice(0, -2));
        } else {
          return "";
        }
      }
    },
    //获取省
    getProvinceList() {
      axios.post(this.url + "/backcash/getprovince").then(res => {
        if (res.data.code == 0) {
          this.provinceList = res.data.data;
        }
      });
    },
    //获取市
    getCityList() {
      if (this.form.province) {
        axios
          .post(this.url + "/backcash/getcity", {
            area_code: this.form.province
          })
          .then(res => {
            if (res.data.code == 0) {
              this.cityList = res.data.data;
            }
          });
      }
    },
    //省选择
    provinceChange() {
      this.form.city = "";
      this.form.area = "";
      this.getCityList();
    },
    //市选择
    cityChange() {
      this.form.area = "";
      this.getAreaList();
    },
    //获取区
    getAreaList() {
      if (this.form.city) {
        axios
          .post(this.url + "/backcash/getarea", {
            city_code: this.form.city
          })
          .then(res => {
            if (res.data.code == 0) {
              this.areaList = res.data.data;
            }
            this.getregionInfo();
          });
      }
    },
    //跳转
    turnAgreement() {
      //保存已经填写的数据
      // localStorage.setItem("formData", JSON.stringify(this.form));
      this.$router.push("/agreement");
    },
    turnPrivacy() {
      this.$router.push("/privacy");
    },
    //  获取验证码
    codeBtn() {
      if (!this.form.phone) {
        this.$message.error("手机号不能为空");
        return;
      }
      if (!this.iscode) {
        return;
      }
      if (this.codeStatus == false) {
        return;
      }
      this.codeStatus = false; //是否能点击
      this.verifyVisible = true;
    },
    sendCode(captcha_token){
      axios
        .post(this.url + "/wbInfo/sendCode", { phone: this.form.phone, captcha_token })
        .then(res => {
          if (res.data.code == 0) {
            this.iscode = false;
            this.tiems = 60;
            let time = setInterval(() => {
              this.tiems--;

              if (this.tiems <= 0) {
                this.codes = "重新获取";
                this.tiems = 60;
                this.iscode = true;
                clearInterval(time);
              }
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
          this.codeStatus = true; //是否能点击
        });
    },
    // 取省市区的名称
    getAreaName(list, name) {
      let that = this;
      list.forEach(item => {
        if (name == "province" && item.area_code == that.form.province) {
          that.form.province = item.area_name;
        } else if (name == "city" && item.area_code == that.form.city) {
          that.form.city = item.area_name;
        } else if (name == "area" && item.area_code == that.form.area) {
          that.form.area = item.area_name;
        }
      });
    },
    // 注册
    register(formName) {
      if (this.checked) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.form.newPassword != this.form.password) {
              this.$message.error("确定密码不对，请重新输入");
              this.form.newPassword = "";
              return;
            }
            // 获取省市区对应的名称
            this.getAreaName(this.provinceList, "province");
            this.getAreaName(this.cityList, "city");
            this.getAreaName(this.areaList, "area");

            let info = JSON.stringify(this.form);
            this.btnloading = true;
            axios.post(this.url + "/wbInfo/register", { info }).then(res => {
              // handle success
              console.log(res);
              this.btnloading = false;
              if (res.data.code === 0) {
                this.wb_id = res.data.data.wb_id;
                this.$message({
                  message: "注册成功",
                  type: "success"
                });

                setTimeout(() => {
                  this.$router.push(
                    `/success?account=${this.form.username}&name=${this.form.realname}`
                  );
                }, 2000);

                //埋点
                axios.post(this.url + "/wbInfo/buryingPoint", {
                  type: 2,
                  snbid: this.form.snbid,
                  wb_id: this.wb_id
                });
              }
              if (res.data.code == -1) {
                this.$message.error(res.data.msg);
              }
            });
          }
        });
      } else {
        this.$message({
          message: "请勾选凡商云购《用户使用协议》",
          type: "warning"
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Home {
  max-width: 1000px;

  margin: 0 auto;
}
.common_top {
  width: 100%;
  padding: 15px 0;
  background: #3e4049;
  display: flex;
  align-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 24px;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 1;
}

.common_top_img {
  margin-left: 40px;
}

.content-main {
  padding: 24px 20px;
}

.main-top {
  width: 100%;
  display: flex;
  justify-content: space-around;
  background: #ff9902;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 6px;
  padding: 20px 0;
  margin-bottom: 15px;
}

.el-form-item {
  width: 95%;
}

.code {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.code .codeInput {
  min-width: 50%;
  max-width: calc(100% - 140px);
}
.code-left {
  background-color: #ff7b08;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  flex-shrink: 0;
  width: 100px;
  text-align: center;
}

.picker_data {
  display: flex;
  flex-direction: column;
}

.picker_data select {
}

/deep/.distpicker-address-wrapper select {
  width: 100% !important;
  margin-bottom: 5px;
}

.agreement {
  text-decoration: none;
  color: #896666;
}

a {
  text-decoration: none;
}

.agreement_box {
  display: flex;

  justify-content: center;
  margin-bottom: 10px;
}

.selectBox {
  width: 100%;
  margin-bottom: 10px;
}

.code-verify {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.code-verify .verify-inner{
  width: 200px;
  background-color: #fff;
  border-radius: 6px;
  padding: 10px;
  position: relative;
  transform: translateY(-5vh);
}
.code-verify .verify-inner .close-btn{
  position: absolute;
  right: -10px;
  top: -10px;
  font-size: 24px;
  cursor: pointer;
  user-select: none;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #000;
}
.code-verify .verify-inner .close-btn i{
  font-size: 14px;
  color: #fff;
}
.code-verify .verify-inner .row{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2px 0;
}
.code-verify .verify-inner .row img{
  width: 100%;
  margin: 5px 0;
  font-size: 14px;
}
.code-verify .verify-inner .row .verify-btn{
  width: 100%;
  margin-top: 5px;
}
</style>
<style>
.el-message-box {
  width: 80vw !important;
}
.code-verify-message{
  z-index: 999999!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue